import './ChatMonitor.css';

const ChatMonitor = () => {
    const starredChats = [
        { name: 'Esther Roy', time: '14 May 2:05pm', unread: '1', star: true },
        { name: 'Esther Roy', time: '14 May 2:05pm', unread: '1', star: true },
        { name: 'Esther Roy', time: '14 May 2:05pm', unread: '5', star: true },
        { name: 'Esther Roy', time: '14 May 2:05pm', unread: '3', star: true },
        { name: 'Esther Roy', time: '14 May 2:01pm', unread: '2', star: true },
        { name: 'Esther Roy', time: '14 May 2:05pm', unread: '1', star: true },
        { name: 'Esther Roy', time: '14 May 3:05pm', unread: '1', star: true },
    ];

    return (
        <div className="chat-monitor-container">
            <div className="cm-header">
                <h2>Chat Monitor</h2>
                <div className="cm-menu-icon" aria-label="Menu">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#172b4d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </div>
            </div>

            <div className="cm-filters">
                <button className="cm-filter-btn">Day</button>
                <button className="cm-filter-btn">Week</button>
                <button className="cm-filter-btn">Month</button>
                <button className="cm-filter-btn active">Year</button>
            </div>

            <div className="cm-date-card">
                <div className="cm-date-field">
                    <label>Start Date</label>
                    <div className="cm-input-box">
                        <span>01-01-2024</span>
                        <div className="cm-calendar-icon"><i class="fa-regular fa-calendar"></i></div>
                    </div>
                </div>
                <div className="cm-date-field">
                    <label>End Date</label>
                    <div className="cm-input-box">
                        <span>25-07-2024</span>
                        <div className="cm-calendar-icon"><i class="fa-regular fa-calendar"></i></div>
                    </div>
                </div>
            </div>

            <div className="cm-grid">
                <div className="cm-col">
                    <div className="cm-section">
                        <h3 className="cm-section-title">Starred Chats</h3>
                        <div className="cm-starred-chats-card">
                            {starredChats.map((chat, i) => (
                                <div className="cm-starred-item" key={i}>
                                    <img src={`https://i.pravatar.cc/150?img=${i + 20}`} alt="avatar" className="cm-avatar" />
                                    <div className="cm-starred-info">
                                        <h4>{chat.name}</h4>
                                        <p>{chat.time}</p>
                                    </div>
                                    <div className="cm-starred-actions">
                                        <span className="cm-star-icon"><i class="fa-solid fa-star"></i></span>
                                        <span className="cm-exclaim-badge">{chat.unread}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="cm-col">
                    <div className="cm-section">
                        <h3 className="cm-section-title">Snippets of Chat</h3>
                        <div className="cm-cards-list">
                            <div className="cm-snippet-card">
                                <div className="cm-snippet-header">
                                    <div className="cm-snippet-user">
                                        <div className="cm-avatar-wrapper">
                                            <img src={`https://i.pravatar.cc/150?img=31`} alt="avatar" className="cm-avatar" />
                                            <span className="cm-status-dot online"></span>
                                        </div>
                                        <div className="cm-snippet-meta">
                                            <h4>Lily Robin</h4>
                                            <p className="cm-action-text"><span className="cm-action-dot"></span>writes</p>
                                        </div>
                                    </div>
                                    <span className="cm-snippet-time">1 minute ago</span>
                                </div>
                                <div className="cm-snippet-content">
                                    <p className="cm-text-content">Most of its text is made up from sections 1.10.32-3 of Cicero's De finibus bonorum et malorum...</p>
                                    <div className="cm-alert-icon">!</div>
                                </div>
                            </div>
                            <div className="cm-snippet-card">
                                <div className="cm-snippet-header">
                                    <div className="cm-snippet-user">
                                        <div className="cm-avatar-wrapper">
                                            <img src={`https://i.pravatar.cc/150?img=12`} alt="avatar" className="cm-avatar" />
                                            <span className="cm-status-dot online"></span>
                                        </div>
                                        <div className="cm-snippet-meta">
                                            <h4>Jared Sunn</h4>
                                            <p className="cm-action-text"><span className="cm-action-dot"></span>records voice message</p>
                                        </div>
                                    </div>
                                    <span className="cm-snippet-time">1 minute ago</span>
                                </div>
                                <div className="cm-snippet-content">
                                    <div className="cm-voice-message">
                                        <div className="cm-voice-waveform">
                                            <i class="fa-solid fa-microphone"></i> <span>Voice message (01:15)</span>
                                        </div>
                                        <div className="cm-voice-actions">
                                            <button className="cm-tag-btn blue"><i class="fa-regular fa-file-lines"></i> Files(4)</button>
                                            <button className="cm-tag-btn pink"><i class="fa-regular fa-image"></i> Photo</button>
                                        </div>
                                    </div>
                                    <div className="cm-alert-icon">!</div>
                                </div>
                            </div>
                            <div className="cm-dark-card">
                                <div className="cm-dark-header">
                                    <img src={`https://i.pravatar.cc/150?img=5`} alt="avatar" className="cm-avatar" />
                                    <div className="cm-dark-meta">
                                        <h4>Nika Jerrado</h4>
                                        <p>last online 5 hours ago</p>
                                    </div>
                                    <span className="cm-dark-time">2 days ago</span>
                                </div>
                                <p className="cm-dark-text">Cicero famously orated against his political opponent Lucius Sergius Catilina.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cm-grid">
                <div className="cm-col">
                    <div className="cm-section">
                        <h3 className="cm-section-title">Highlights ( Positive)</h3>
                        <div className="cm-cards-list">
                            <div className="cm-snippet-card">
                                <div className="cm-snippet-header">
                                    <div className="cm-snippet-user">
                                        <div className="cm-avatar-wrapper">
                                            <img src={`https://i.pravatar.cc/150?img=31`} alt="avatar" className="cm-avatar" />
                                            <span className="cm-status-dot online"></span>
                                        </div>
                                        <div className="cm-snippet-meta">
                                            <h4>Lily Robin</h4>
                                            <p className="cm-action-text"><span className="cm-action-dot"></span>writes</p>
                                        </div>
                                    </div>
                                    <span className="cm-snippet-time">1 minute ago</span>
                                </div>
                                <div className="cm-snippet-content">
                                    <p className="cm-text-content">Most of its text is made up from sections 1.10.32-3 of Cicero's De finibus bonorum et malorum...</p>
                                    <div className="cm-alert-icon">!</div>
                                </div>
                            </div>
                            <div className="cm-snippet-card">
                                <div className="cm-snippet-header">
                                    <div className="cm-snippet-user">
                                        <div className="cm-avatar-wrapper">
                                            <img src={`https://i.pravatar.cc/150?img=12`} alt="avatar" className="cm-avatar" />
                                            <span className="cm-status-dot online"></span>
                                        </div>
                                        <div className="cm-snippet-meta">
                                            <h4>Jared Sunn</h4>
                                            <p className="cm-action-text"><span className="cm-action-dot"></span>records voice message</p>
                                        </div>
                                    </div>
                                    <span className="cm-snippet-time">1 minute ago</span>
                                </div>
                                <div className="cm-snippet-content">
                                    <div className="cm-voice-message">
                                        <div className="cm-voice-waveform">
                                            <i class="fa-solid fa-microphone"></i> <span>Voice message (01:15)</span>
                                        </div>
                                        <div className="cm-voice-actions">
                                            <button className="cm-tag-btn blue"><i class="fa-regular fa-file-lines"></i> Files(4)</button>
                                            <button className="cm-tag-btn pink"><i class="fa-regular fa-image"></i> Photo</button>
                                        </div>
                                    </div>
                                    <div className="cm-alert-icon">!</div>
                                </div>
                            </div>
                            <div className="cm-dark-card">
                                <div className="cm-dark-header">
                                    <img src={`https://i.pravatar.cc/150?img=5`} alt="avatar" className="cm-avatar" />
                                    <div className="cm-dark-meta">
                                        <h4>Nika Jerrado</h4>
                                        <p>last online 5 hours ago</p>
                                    </div>
                                    <span className="cm-dark-time">2 days ago</span>
                                </div>
                                <p className="cm-dark-text">Cicero famously orated against his political opponent Lucius Sergius Catilina.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cm-col">
                    <div className="cm-section">
                        <h3 className="cm-section-title">Highlight ( Negative)</h3>
                        <div className="cm-cards-list">
                            <div className="cm-snippet-card">
                                <div className="cm-snippet-header">
                                    <div className="cm-snippet-user">
                                        <div className="cm-avatar-wrapper">
                                            <img src={`https://i.pravatar.cc/150?img=31`} alt="avatar" className="cm-avatar" />
                                            <span className="cm-status-dot online"></span>
                                        </div>
                                        <div className="cm-snippet-meta">
                                            <h4>Lily Robin</h4>
                                            <p className="cm-action-text"><span className="cm-action-dot"></span>writes</p>
                                        </div>
                                    </div>
                                    <span className="cm-snippet-time">1 minute ago</span>
                                </div>
                                <div className="cm-snippet-content">
                                    <p className="cm-text-content">Most of its text is made up from sections 1.10.32-3 of Cicero's De finibus bonorum et malorum...</p>
                                    <div className="cm-alert-icon">!</div>
                                </div>
                            </div>
                            <div className="cm-snippet-card">
                                <div className="cm-snippet-header">
                                    <div className="cm-snippet-user">
                                        <div className="cm-avatar-wrapper">
                                            <img src={`https://i.pravatar.cc/150?img=12`} alt="avatar" className="cm-avatar" />
                                            <span className="cm-status-dot online"></span>
                                        </div>
                                        <div className="cm-snippet-meta">
                                            <h4>Jared Sunn</h4>
                                            <p className="cm-action-text"><span className="cm-action-dot"></span>records voice message</p>
                                        </div>
                                    </div>
                                    <span className="cm-snippet-time">1 minute ago</span>
                                </div>
                                <div className="cm-snippet-content">
                                    <div className="cm-voice-message">
                                        <div className="cm-voice-waveform">
                                            <i class="fa-solid fa-microphone"></i> <span>Voice message (01:15)</span>
                                        </div>
                                        <div className="cm-voice-actions">
                                            <button className="cm-tag-btn blue"><i class="fa-regular fa-file-lines"></i> Files(4)</button>
                                            <button className="cm-tag-btn pink"><i class="fa-regular fa-image"></i> Photo</button>
                                        </div>
                                    </div>
                                    <div className="cm-alert-icon">!</div>
                                </div>
                            </div>
                            <div className="cm-dark-card">
                                <div className="cm-dark-header">
                                    <img src={`https://i.pravatar.cc/150?img=5`} alt="avatar" className="cm-avatar" />
                                    <div className="cm-dark-meta">
                                        <h4>Nika Jerrado</h4>
                                        <p>last online 5 hours ago</p>
                                    </div>
                                    <span className="cm-dark-time">2 days ago</span>
                                </div>
                                <p className="cm-dark-text">Cicero famously orated against his political opponent Lucius Sergius Catilina.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatMonitor;
